import React from 'react';

import {
  DateField,
  email,
  Labeled,
  TextField,
  usePermissions,
} from 'react-admin';

import {
  Box,
  Card,
  CardHeader,
  Grid,
  CardContent,
  Typography,
  Divider,
} from '@mui/material';

import EditField from '../../../customFields/EditField';
import RelatedIndividualsListPreview from './kyc/relatedIndividuals/RelatedIndividualsListPreview';
import hasAccess from '../../../utilities/hasAccess';
import LatestRelatedRequests from '../../../customFields/LatestRelatedRequests';
import LatestRelatedCases from '../../../customFields/LatestRelatedCases';
import LatestRelatedPings from '../../../customFields/LatestRelatedPings';
import RelatedConductors from '../../../customFields/RelatedConductors';
import PerformKyc from '../../../customFields/PerformKyc';
import EditSelectInput from '../../../customFields/EditSelectInput';

import countries from '../../../constants/countries';
import actions, { Actions } from '../../../constants/actions';

import RiskManagement from '../../riskManagment';
import RelatedCustomConnections from '../../connection/RelatedCustomConnections';
import RelatedIpAddresses from '../../ipUsage/RelatedIpAddresses';
import DeviceUsages from '../../entities/DeviceUsages';
import EditArrayInput from '../../../customFields/EditArrayInput';

const Information = () => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Grid container spacing={6}>
      <Grid
        size={{
          xs: 12,
          lg: 5,
        }}
      >
        <Card variant="outlined">
          <CardHeader
            title="Business details"
            action={
              hasAccess(permissions, actions.REQUEST_CREATE) && (<PerformKyc />)
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid size={12}>
                <Box flexDirection="column" display="flex">
                  <Typography variant="smallTitle">ID</Typography>
                  <TextField source="id" label="ID" />
                </Box>
              </Grid>
              <Grid size={12}>
                <Box>
                  <Labeled label="Created at">
                    <DateField source="createdAt" />
                  </Labeled>
                </Box>
              </Grid>
              <Grid size={12}>
                <EditArrayInput showEdit={hasAccess(permissions, actions.BUSINESS_UPDATE)} source="customIds" label="Custom IDs" />
              </Grid>
              <Grid size={12}>
                <EditField showEdit={hasAccess(permissions, actions.BUSINESS_UPDATE)} source="name" label="Name" />
              </Grid>
              <Grid size={12}>
                <EditField showEdit={hasAccess(permissions, actions.BUSINESS_UPDATE)} source="registrationNumber" label="Registration number" />
              </Grid>
              <Grid size={12}>
                <EditSelectInput choices={countries} showEdit={hasAccess(permissions, actions.BUSINESS_UPDATE)} source="residence" label="Registration country" />
              </Grid>
              <Grid size={12}>
                <EditField showEdit={hasAccess(permissions, actions.BUSINESS_UPDATE)} source="email" label="Email" validate={[email()]} />
              </Grid>
              <Grid size={12}>
                <EditField showEdit={hasAccess(permissions, actions.BUSINESS_UPDATE)} source="phoneNumber" label="Phone number" />
              </Grid>
              <Grid size={12}>
                <EditField showEdit={hasAccess(permissions, actions.BUSINESS_UPDATE)} type="date" source="kycApprovedAt" label="KYC approved" />
              </Grid>
              <Grid size={12}>
                <RiskManagement />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid
        container
        direction="column"
        size={{
          xs: 12,
          lg: 7,
        }}
      >
        <Grid>
          <Card variant="outlined">
            <CardHeader title="Current Board Members, Directors, and Beneficial Owners" />
            <Divider />
            <CardContent>
              <RelatedIndividualsListPreview />
            </CardContent>
          </Card>
        </Grid>
        <Grid>
          <RelatedCustomConnections />
        </Grid>
        <Grid>
          <RelatedIpAddresses />
        </Grid>
        <Grid>
          <DeviceUsages />
        </Grid>
      </Grid>
      <RelatedConductors />
      <LatestRelatedRequests />
      <LatestRelatedCases />
      <LatestRelatedPings />
    </Grid>
  );
};

export default Information;
